
import TextalignRight from "../../../assets/duotone/TextalignRight.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TextalignRightIcon({ className, dataTestid = "TextalignRightIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TextalignRight data-testid={dataTestid} className={classes} {...rest} />
  );
}
